<template>
  <div>
    <el-dialog
      top="10vh"
      width="560px"
      center
      title="补单"
      :visible.sync="dialogVisible"
      @close="HandleCancel"
    >
      <el-form label-width="100px" :ref="form">
        <el-form-item label="平台订单号">
          {{ orderData.orderId }}
        </el-form-item>
        <el-form-item label="凭证">
          {{ fixingData.smsReceipt ? `【短信】${fixingData.smsReceipt}` : "" }}
          {{
            fixingData.transdetailReceipt
              ? `【银行流水】${fixingData.transdetailReceipt}`
              : ""
          }}
        </el-form-item>
        <el-form-item label="订单金额">
          {{ formatNumberWithCommasAndDecimalSeparator(orderData.billCost, 2) }}
        </el-form-item>
        <el-form-item label="凭证金额">
          {{ formatNumberWithCommasAndDecimalSeparator(fixingData.amount, 2) }}
        </el-form-item>
        <el-form-item label="打款人姓名" v-if="orderType === 'pay'">
          <el-input
            :disabled="tempOrderMergeObj.isCombinedTempOrder"
            size="mini"
            v-model="transPayName"
            style="width: 160px"
          />

          <!-- Start 合并暂存支付订单 -->
          <div v-if="tempOrderMergeObj.isCombinedTempOrder">
            <el-tag type="success" size="mini" effect="dark"
              >合并暂存支付订单：
              {{ transPayName }}
            </el-tag>
          </div>
          <!-- End 合并暂存支付订单 -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel"> 关闭 </el-button>
        <el-button
          :loading="loading"
          round
          type="success"
          @click="HandleSubmit()"
        >
          保存
        </el-button>
      </span>
    </el-dialog>

    <!-- 合并暂存支付订单 -->
    <TempPayReceiptMerge
      :temp-pay-receipt-merge-dialog-obj.sync="tempPayReceiptMergeDialogObj"
    />
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { withdrawOrderSupplement, payOrderSupplement } from "@/api/order";
import TempPayReceiptMerge from "@/views/components/dialog/TempPayReceiptMerge";

export default {
  mixins: [mainCommon],
  components: { TempPayReceiptMerge },
  props: ["orderFixingDialog", "fixingData", "orderData", "orderType"],
  data() {
    return {
      form: "form",
      loading: false,
      transPayName: "", // 打款人姓名
      tempPayReceiptMergeDialogObj: {}, // 合并暂存支付订单弹框
      tempOrderMergeObj: {}, // 合并订单数据
    };
  },
  watch: {
    /* --- Start 合并暂存支付订单 --- */
    tempPayReceiptMergeDialogObj(row) {
      if (row && row.mergePayName && row.mergeAmount && row.tempOrderId) {
        // 若确定合并，则覆盖原本的付款人姓名
        this.transPayName = row.mergePayName;
        this.tempOrderMergeObj.tempOrderId = row.tempOrderId;
        this.tempOrderMergeObj.isCombinedTempOrder = row.isCombinedTempOrder;
      }
    },
    fixingData(row) {
      if (row && row.amount && row.bankNo) {
        // 给 "金额"＋"银行卡号" 取得暂存支付订单列表
        this.tempPayReceiptMergeDialogObj = {
          amount: row.amount, // 金额
          bankNo: row.bankNo, // 银行卡号
        };
      }
    },
    /* --- End 合并暂存支付订单 --- */

    orderFixingDialog(row) {
      if (row && this.orderData.tempPayerName) {
        // 带入订单打款人姓名
        this.transPayName = this.orderData.tempPayerName;
      }
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.orderFixingDialog;
      },
      set(val) {
        this.$emit("update:orderFixingDialog", val);
      },
    },
  },
  methods: {
    HandleCancel() {
      this.dialogVisible = false;
      this.transPayName = "";
      this.tempOrderMergeObj = {};
    },
    HandleSubmit() {
      this.$confirm("确定要补单吗？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning",
      })
        .then(() => {
          let dataObj = {
            orderId: this.orderData.id,
            receiptId: this.fixingData.id,
            tempOrderId: this.tempOrderMergeObj.tempOrderId, // 暂存订单号
            isCombinedTempOrder: this.tempOrderMergeObj.isCombinedTempOrder, // 是否为结合暂存订单
          };

          this.loading = true;
          if (this.orderType === "pay") {
            dataObj.transPayName = this.transPayName;
            payOrderSupplement(dataObj)
              .then((res) => {
                this.$notify.success(res.message);
                this.HandleCancel();
                this.$emit("update:dialog-visible", false);
              })
              .finally(() => {
                this.loading = false;
              });
          } else if (this.orderType === "withdraw") {
            withdrawOrderSupplement(dataObj)
              .then((res) => {
                this.$notify.success(res.message);
                this.HandleCancel();
                this.$emit("update:dialog-visible", false);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        })
        .catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OrderFixing.vue